/**
 * SiteStructuredData — injiziert Organization + WebSite + LocalBusiness
 * JSON-LD in <head>. Nutzt useHeadJsonLd (direkte DOM-Manipulation), weil
 * react-helmet-async <script>-Tags entfernt, wenn mehrere Helmet-Instanzen
 * konkurrieren (App-Level + Page-Level).
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHeadJsonLd } from '@/hooks/useHeadInjection';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SiteStructuredData() {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/api/shop/seo/site`).then((r) => setData(r.data)).catch(() => {});
  }, []);
  useHeadJsonLd(data?.organization || null, 'site-organization');
  useHeadJsonLd(data?.website || null, 'site-website');
  useHeadJsonLd(data?.local_business || null, 'site-local-business');
  return null;
}
